import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import 'moment/locale/es';
import Icon from '@icon-park/react/es/all';
import i18n from 'i18next';
import API from '../../../graphql/createClient';
import { updatePlatformUser } from '../../../graphql/mutations';
import Menu from '../../skeleton/menu/Menu';
import './LanguageSwitcher.scss';
function LanguageSwitcher({ action = () => { }, identity = {} }) {
    const { t } = useTranslation();
    const changeLanguage = (lng) => {
        action();
        i18n.changeLanguage(lng);
        moment.locale(lng);
        if (identity.id) {
            API.graphql({
                query: updatePlatformUser,
                variables: {
                    input: {
                        account: identity.account_id,
                        id: identity.id,
                        localization: lng,
                    },
                },
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { customButton: React.createElement(React.Fragment, null,
                t('Language '),
                React.createElement(Icon, { type: "earth", theme: "multi-color", size: 16, strokeWidth: 3 })) },
            React.createElement("div", { onClick: () => changeLanguage('en'), className: `language-select ${i18n.language === 'en' ? 'selected' : ''}` }, "English"),
            React.createElement("div", { onClick: () => changeLanguage('es'), className: `language-select ${i18n.language === 'es' ? 'selected' : ''}` }, "Espanol"))));
}
export default LanguageSwitcher;
